import { http } from '../../../../api/axios';
import { reservesConfig } from '../../../../config';

export const apiChangeReserveReportSettings = (message: string) => {
    return http.post(reservesConfig().endpointReserveListDefaultSettingChange, message);
};
